import { useTranslation } from 'react-i18next';

import { PodcastsElement } from '@shared/dream-components';

import { usePodcastsContext } from '~/context/SubscriptionManagement';

/**
 * Renders the Podcasts tab — the subscriber's podcast shows. Shows (already reshaped with the
 * `isActive` flag), loading state, and the href builder come from `PodcastsProvider` via context.
 * Pure UI, no props, no data logic.
 */
export const PodcastsSection = () => {
  const { t } = useTranslation();
  const { shows, isLoadingPodcasts, getPodcastHref } = usePodcastsContext();

  if (isLoadingPodcasts) {
    return (
      <div className="flex flex-col w-full gap-4">
        <p className="text-sm text-gray-500">{t('manage.podcasts.loading', { defaultValue: 'Loading podcasts…' })}</p>
      </div>
    );
  }

  if (shows.length === 0) {
    return null;
  }

  return (
    <PodcastsElement
      element={{
        type: 'subscriptionPodcastShows',
        attrs: {
          data: { shows },
        },
      }}
      isLive
      translations={{
        'manage.podcasts.title': t('manage.podcasts.title', { defaultValue: 'Your podcasts' }),
        'manage.podcasts.description': t('manage.podcasts.description', {
          defaultValue: 'Choose a podcast to add to your favorite podcast app',
        }),
        'manage.podcasts.inactive_message': t('manage.podcasts.inactive_message', {
          defaultValue: 'Your subscription is inactive. Reactivate to access podcast feeds.',
        }),
        'manage.podcasts.status.inactive': t('manage.podcasts.status.inactive', {
          defaultValue: 'Subscription inactive',
        }),
        'manage.podcasts.setup_app': t('manage.podcasts.setup_app', {
          defaultValue: 'Set up podcast app',
        }),
        'manage.podcasts.premium_badge': t('manage.podcasts.premium_badge', { defaultValue: 'PREMIUM' }),
      }}
      getPodcastHref={getPodcastHref}
    >
      {null}
    </PodcastsElement>
  );
};
